import { useContext, useEffect, useState } from 'react';
import api from '../api/api';
import { Workspace } from '../models/common-types';
import { getParam, updateParam } from '../utils/communication';
import _ from 'lodash';
import useModal from './useModal';
import NoWorkspacesDialog from '../dialogs/NoWorkspacesDialog/NoWorkspacesDialog';
import { useQuery } from 'react-query';
import constants from '../constants/constants';
import { AuthContext } from './authContext';

export default function useWorkspaces(dialog: ReturnType<typeof useModal>) {
    const { user } = useContext(AuthContext);
    const [activeWorkspace, setActiveWorkspace] = useState<Workspace | null | undefined>(undefined);
    const [workspaces, setWorkspaces] = useState<Workspace[]>();
    useQuery(['workspaces', user?.id], () => api.workspaces.fetchAssignedWorkspaces(), {
        enabled: !!user?.id,
        refetchInterval: constants.WORKSPACES_POLLING_DELAY,
        onSuccess: (wsFromApi) => {
            const queryWorkspace = _.find(wsFromApi, { id: getParam('workspaceId') });
            const storedWorkspace = _.find(wsFromApi, { id: localStorage.getItem(`id_${user?.id}_workspace`) });
            setWorkspaces(wsFromApi);
            if (wsFromApi.length) {
                setActiveWorkspace(queryWorkspace || storedWorkspace || wsFromApi[0]);
            }
        },
        onError: () => {
            if (!workspaces?.length) {
                if (user?.role === 'Regular') {
                    dialog.open(NoWorkspacesDialog, null);
                }
                setActiveWorkspace(null);
            }
        },
    });

    useEffect(() => {
        if (activeWorkspace?.id) {
            updateParam('workspaceId', activeWorkspace.id);
            localStorage.setItem(`id_${user?.id}_workspace`, activeWorkspace.id);
            sessionStorage.setItem('workspace', activeWorkspace.id);
        }
    }, [activeWorkspace, user?.id]);

    return {
        workspaces,
        activeWorkspace,
        setActiveWorkspace,
    };
}
